import { node } from "~/util/dom";

export function createMapBestfit(): HTMLDivElement {
	return node("div", { className: "ui-map-bestfit" });
}
